import { useState, useEffect } from 'react'

let lastScrollY = 0
let sideEffectShow = true

export default function useScrollNav(alwaysShow = false) {
  const isClient = typeof window === 'object'
  const [isBelowFold, setIsBelowFold] = useState(false)
  const [show, setShow] = useState(true)
  useEffect(() => {
    if (!isClient) {
      return false
    }
    function handleScroll() {
      if (window.scrollY < 50) {
        sideEffectShow = true
        setShow(true)
      } else {
        let scrollingUp = window.scrollY - lastScrollY < -5
        let scrollingDown = window.scrollY - lastScrollY > 5
        if (!sideEffectShow && scrollingUp) {
          sideEffectShow = true
          setShow(true)
        } else if (sideEffectShow && scrollingDown) {
          sideEffectShow = false
          setShow(false)
        }
      }
      lastScrollY = window.scrollY
      setIsBelowFold(window.scrollY > 700)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, []) // Empty array ensures that effect is only run on mount and unmount
  return { isBelowFold, show: alwaysShow ? true : show }
}
